<template>
  <v-select v-if="useVuetify" v-bind="$attrs" :items="items" :item-props="itemProps"  v-model="modelValue">
    <slot></slot>
  </v-select>
  <select v-else v-bind="$attrs" v-model="modelValue">
    <option v-for="item in items" :value="item">{{ itemProps(item).title }}</option>
  </select>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { computed, inject } from 'vue'

const props = defineProps({
  items: Array,
  labelFunction: {
    type: Function,
    required: true,
  },
  nullable: Boolean,
})

const modelValue = defineModel({
  type: Object as any,
})

defineOptions({
  inheritAttrs: false
})


function itemProps(item){
  return {
    title: item ? props.labelFunction(item) : props.placeholder,
    value: item ?? null,
  }
}

const useVuetify = inject("useVuetify",false);
</script>